import { Button, Header, Paragraph } from 'components/patterns'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import ProductFeatureGroup from 'components/patterns/ProductFeatureGroup'
import React from 'react'
import { useDispatch } from 'react-redux'
import { createFeatureRevision } from 'actions/feature/features'
import strings from 'utils/strings'
import { themeColor } from 'utils/styles'
import IconAlert from 'components/patterns/Icon/components/Icon__Alert'
import { useFeatureCanCreateRevision } from './useFeatureRevision'

export default function CreateFeatureRevisionButton({ featureId, onClick }) {
  const dispatch = useDispatch()
  const canCreateRevision = useFeatureCanCreateRevision(featureId)
  const [showModal, setShowModal] = React.useState(false)

  const handleOpenModal = () => {
    setShowModal(true)
  }
  const handleCloseModal = () => {
    setShowModal(false)
  }
  const handleCreateFeatureRevision = (...args) => {
    dispatch(createFeatureRevision(featureId))
    if (onClick) {
      onClick(featureId, ...args)
    }
  }

  if (showModal) {
    return (
      <ModalSpecial>
        <ModalContentArea>
          <div className="header-row">
            <IconAlert />
            <Header className="revision-creation-header" type="h4">
              {strings.are_you_sure_you_want_to_convert_this_feature}
            </Header>
          </div>
          <div className="paragraph-row">
            <Paragraph className="revision-creation-paragraph">
              {strings.when_the_next_version_of_this_feature}
            </Paragraph>
          </div>
        </ModalContentArea>
        <ModalFooterArea>
          <Button
            className="revision-creation-button-cancel"
            type="secondary"
            onClick={handleCloseModal}
          >
            {strings.cancel}
          </Button>
          <Button
            className="revision-creation-button"
            type="primary"
            onClick={handleCreateFeatureRevision}
          >
            {strings.create_revision}
          </Button>
        </ModalFooterArea>
      </ModalSpecial>
    )
  }

  return (
    <ProductFeatureGroup name="revise-active-feature" featureId={featureId}>
      <Button
        type="secondary"
        size="small"
        style={{ float: 'right', margin: 0 }}
        onClick={handleOpenModal}
        disabled={!canCreateRevision}
      >
        {strings.create_revision}
      </Button>
    </ProductFeatureGroup>
  )
}

CreateFeatureRevisionButton.propTypes = {
  featureId: PropTypes.string.isRequired,
  onClick: PropTypes.func,
}

const ModalSpecial = styled.div`
  position: fixed;
  top: 0px;
  right: 0;
  bottom: 0;
  width: 425px;
  z-index: 1000;
  background-color: white;
  display: flex;
  flex-direction: column;
`

const ModalContentArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 45px 20px;
  flex: 1;

  .header-row {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .paragraph-row {
    padding-left: 35px;
  }

  .revision-creation-header {
    color: ${themeColor('blackSecondary')};
    font-family: Arial, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    margin: 0;
  }

  .revision-creation-paragraph {
    color: ${themeColor('blackSecondary')};
    font-family: Arial, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    margin: 0;
  }
`

const ModalFooterArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  border-top: 1px solid #e3e5e8;
  background: ${themeColor('whitePrimary')};

  .revision-creation-button-cancel {
    && {
      display: flex;
      padding: 11px 12px;
      align-items: center;
      gap: 4px;
      border-radius: 3px;
      border: 1px solid ${themeColor('slateLight')};
      background: ${themeColor('whitePrimary')};
      font-size: 16px;
      height: auto;
      margin: 0;
    }
  }

  .revision-creation-button {
    && {
      display: flex;
      padding: 11px 12px;
      align-items: center;
      gap: 4px;
      border-radius: 3px;
      background: ${themeColor('bluePrimary')};
      font-size: 16px;
      height: auto;
      margin: 0;
    }
  }
`
